import LoyaltyProgramState from '../types/LoyaltyProgramState'

export const state: LoyaltyProgramState = {
  tiers: [],
  customer: null,
  dashboard: null,
  cartItems: []
}
